import validate from 'validate.js'

const constraints = {
  statusPlan: {
    presence: true
  },
  planId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
